import styled from 'styled-components';

export const QuestionWrap = styled.div`
  margin-bottom: 32px;
`;
export const Question = styled.div`
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 8px;
`;
export const Answer = styled.div`
  display: flex;
`;
export const AnswerVertical = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const PolicyLink = styled.a`
  color: #1cc67f;
  outline: none;

  font-weight: bold;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: #1cc67f;
    outline: none;
  }
`;
